import { useEffect, useState } from 'react';
import { addCommas } from '../utils/numberUtils';
import { formatCurrencyV2 } from '../common/formatCurrency';
import { LoadingEllipsis } from '../common/LoadingEllipsis';
import { StateInfoData } from './types/StateInfoData';

const STATE_INFO_URL = `${baseFrontURL}donors/state-info.json`;

function formatFunds(num: number): string {
    num = Math.abs(Number(num));
    let numberValue;
    if (num >= 1.0e+9) {
        numberValue = (num / 1.0e+9).toFixed(2);
        return `$${numberValue} billion`;
    } else if (num >= 1.0e+6) {
        numberValue = (num / 1.0e+6).toFixed(2);
        return `$${numberValue} million`;
    }
    return formatCurrencyV2(num, 'HIDE_CENTS');
}

export const StateInfo = function ({ stateCode }: { stateCode: string }) {
    const [stateInfo, setStateInfo] = useState<StateInfoData | null>(null);
    const [loadingInfo, setLoadingInfo] = useState(false);

    useEffect(() => {
        setStateInfo(null);
        if (stateCode?.length === 2) {
            getStateInfo(stateCode);
        }
    }, [stateCode]);

    const getStateInfo = function (stateCode: string) {
        setLoadingInfo(true);
        $.getJSON(
            STATE_INFO_URL,
            { stateCode },
        ).done((newStateInfo: StateInfoData) => {
            setLoadingInfo(false);
            setStateInfo(newStateInfo);
        }).fail(() => {
            setLoadingInfo(false);
            console.error('Failed to load state info');
        });
    };

    if (loadingInfo) {
        return <LoadingEllipsis />;
    }

    if (!stateInfo) {
        return null;
    }

    return <div className="state-info">
        <div className="row1">
            <p className="funds-before">Since 2000, in {stateInfo.stateName} we&#39;ve raised</p>
            <strong className="funds">{ formatFunds(stateInfo.totalFundsRaised) }</strong>
            <p className="funds-after">for teachers and students</p>
        </div>
        <div className="fluid-container row2">
            <div className="donors col col4">
                <strong>{ addCommas(stateInfo.totalDirectSupporters) }</strong>
                Donors
            </div>
            <div className="projects-funded col col4">
                <strong>{ addCommas(stateInfo.fundedProjects) }</strong>
                Projects funded
            </div>
            <div className="teachers-supported col col4">
                <strong>{ addCommas(stateInfo.fundedTeachers) }</strong>
                Teachers supported
            </div>
        </div>
        <div className="fluid-container row3">
            <div className="books col col3">
                <strong>{ addCommas(stateInfo.bookProjects) }</strong>
                Books
            </div>
            <div className="art col col3">
                <strong>{ addCommas(stateInfo.artSupplyProjects) }</strong>
                Art supplies
            </div>
            <div className="tech col col3">
                <strong>{ addCommas(stateInfo.techProjects) }</strong>
                Tech projects
            </div>
            <div className="basics col col3">
                <strong>{ addCommas(stateInfo.basicSupplyProjects) }</strong>
                Basic supplies
            </div>
        </div>
    </div>;
};
